/**
 * Skeleton Component
 */

import React, { FC, Fragment } from 'react';
import { SkeletonProps } from './skeleton.types';
import { StyledBaseSkeleton } from './skeleton.style';
import { withTheme } from 'styled-components';

const getLoadingClassName: Function = (className: string, isLoading: boolean) => {
  let temp: string[] = [className];

  if (isLoading) {
    temp.push('is-loading');
  }

  return temp.join(' ');
};

const Skeleton: FC<SkeletonProps> = ({
    height = '100%',
    width = '100%',
    borderRadius = 5,
    isCircle = false,
    animation = true,
    theme = {},
    isLoading,
    children,
    className,
    margin = 5,
    count = 1
  }: SkeletonProps) => {
    const skeletonArr = [];
    const completeProps: SkeletonProps = {
      height,
      width,
      borderRadius,
      animation,
      isCircle,
      theme, 
      children,
      className,
      margin,
      count,
      isLoading
    }

    for (let i = 0; i < count; i++) {
      const skeletonItemId: string = `skeleton-item-${i}`;
      if (typeof isLoading !== 'undefined') {
        const completePropsNew: SkeletonProps = {
          ...completeProps,
          className: getLoadingClassName(className, isLoading)
        };
        skeletonArr.push(
        <StyledBaseSkeleton 
          {...completePropsNew}
          key={skeletonItemId}
        >
          <span>{children}</span>
        </StyledBaseSkeleton>
      )
      } else {
        skeletonArr.push(
          <StyledBaseSkeleton
            {... completeProps}
            key={skeletonItemId}
          />
        );
      }
    }
    
    return (
      <Fragment>
        {skeletonArr}
      </Fragment>
  );
};

export default withTheme(Skeleton);
